import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from 'lucide-react'
import axios from 'axios'
import { getVendeursByUserCat } from '../../lib/apis'
import Loader from '../../components/loader'
import Card_vendeur from '../../components/Card_vendeur'
import Breadcrumb from '../../components/Breadcrumb'
import { scrollToTop } from '../../lib/utils'

function List_Producteur() {
    const { t } = useTranslation()
    const [vendeurs, setVendeurs] = useState([])
    const [searchVendeur, setSearchVendeur] = useState([])
    const [loader, setLoader] = useState(true)
    const locations = useLocation()
    const navigate = useNavigate()
    const userCategorie = locations.state
    const updateVendeur = async () => {
        try {
            const { data } = await axios.get(`${getVendeursByUserCat}/${userCategorie.acteur_id}/vendeurs`)
            setVendeurs(data.data)
            setSearchVendeur(data.data)
        } catch (error) {
            console.log(error)
        } finally {
            setLoader(false)
        }
    }

    useEffect(() => {
        scrollToTop()
    }, [])

    useEffect(() => {
        updateVendeur()
    }, [])
    const search = (e: any) => {
        const value = e.target.value
        if (value) {
            const tmpVendeur = vendeurs.filter((vendeur: any) => vendeur?.name?.toLowerCase().includes(value) || vendeur?.region?.toLowerCase().includes(value) || vendeur?.departement?.toLowerCase().includes(value) || vendeur?.city?.toLowerCase().includes(value))
            setSearchVendeur(tmpVendeur)
        } else {
            setSearchVendeur(vendeurs)
        }
    }
    console.log(vendeurs.length)
    return (
        <div className='w-[100vw]'>
            <header style={{
                backgroundImage: `url(${userCategorie.image_url})`
            }} className=' bg-cover bg-center bg-no-repeat w-full h-[70vh]'>
                <div className='w-full  px-8 py-1 h-full bg-gradient-to-r from-green-900 to-green-500/0'>
                    <p onClick={() => navigate("/")} className=' cursor-pointer flex mt-8 text-[15px] font-[400] flex-row text-white'>
                        <ArrowLeft size={20} className='mr-5' />
                        {t("back_to_home")}
                    </p>
                    <h1 className='text-[64px] mt-5 font-sans text-white font-bold' >{t(userCategorie.acteur_name)}</h1>
                    <div className='w-[60%]'>
                        <p className='text-white mt-3 text-[15px] '>{t(userCategorie.description)}</p>
                    </div>

                    <div className='bg-white mt-5 w-[200px] text-[15px] font-[400] flex items-center justify-center rounded-sm'>
                        {loader ? "..." : `${vendeurs.length} ${t("vendeur_disponible")}`}
                    </div>
                </div>
            </header>
            <section className=' m-5 '>
                <Breadcrumb />
                <div className='w-full flex items-center p-2 justify-center'>
                    <input onChange={(e) => search(e)} className='bg-gray-100 tex-[12px] h-[35px] placeholder:text-[12px] placeholder:text-[#868889] w-[100%] md:w-[50%] rounded-[20px]  px-5' placeholder={t("placeholder_search_vendeur")} type="search" />
                </div>
                <div className=' w-full mt-3 mb-1 flex flex-wrap justify-center md:justify-start items-center gap-2'>
                    {
                        loader ? <Loader /> :
                            searchVendeur.map((vendeur: any) => {
                                return (
                                    <Card_vendeur key={vendeur.user_id} name={userCategorie.acteur_name} vendeur={vendeur} />
                                )
                            })
                    }
                </div>
            </section>
        </div>
    )
}

export default List_Producteur